// The services index: its search box is a Sprig component, and the clear
// button, the quick tabs and the header's menu toggle all empty it. The menu
// toggle is in the header, which outlives the page, so its listener is on the
// page's signal.
export function mountServicesSearch({ root, signal }) {
  const clear = () => {
    root.querySelectorAll(".service-search__input").forEach((input) => (input.value = ""));
    root.querySelectorAll(".service-search__results-list").forEach((list) => list.remove());
  };
  const buttons = [
    ...root.querySelectorAll(".service-search__clear-search-btn, .service-search__quick-tab-btn"),
    ...document.querySelectorAll(".nav__icon-toggle"),
  ];
  buttons.forEach((button) => button.addEventListener("click", clear, { signal }));
}
